module.exports = __webpack_public_path__ + "static/bg-modal-ac00f87750df6d0bfacf5165025e8f80.jpg";